import { encodeUrl } from '@/utils';
import { getProfessionalData } from '@/utils/cookies';
import { canProfessionalManageP2PSession } from '@/utils/sessionScheduledBy';

export const getP2PPatientIdFromSession = (
	session: Sessions.Session,
): string | null => {
	const participant = session.participants?.find(
		(p) => p.entity_type === 'PATIENT' || p.patient_id,
	);

	return participant?.patient_id ?? participant?.patient?.id ?? null;
};

const buildPrefillDateYmd = (date: Date) => {
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, '0');
	const d = String(date.getDate()).padStart(2, '0');
	return `${y}-${m}-${d}`;
};

/** Parâmetros codificados (`d=`) para `/profissional/consultas/agendar` em modo edição. */
export const buildProfessionalSessionEditUrlEncoded = (
	session: Sessions.Session,
): string | null => {
	if (!canProfessionalManageP2PSession(session)) return null;

	const professional = getProfessionalData();
	if (!professional?.id) return null;

	const patientId = getP2PPatientIdFromSession(session);
	if (!patientId) return null;

	const sessionDate = new Date(session.selected_date);
	const serviceId =
		session.service_id ||
		professional.professional_services?.[0]?.service?.id ||
		'';

	return encodeUrl({
		s: '1',
		session_id: session.id,
		patient_id: patientId,
		professional_id: professional.id,
		service_id: serviceId,
		user_ids: '[]',
		prefill_date: buildPrefillDateYmd(sessionDate),
		prefill_hour: String(sessionDate.getHours()),
	});
};
